import React, { useState, useEffect } from "react";

import SearchResults from "../../components/SearchResults";
import { searchDetails } from "../../services/MetadataService";

const SearchLanding = (props) => {
    const [searchResults, setSearchResults] = useState();

    useEffect(() => {
        if (!searchResults) {
            searchDetails(props.searchTerm).then(data => {
                setSearchResults(data)
            })
        }
    },[props.searchTerm])

    return <div className="layer3">
        <SearchResults searchTerm={props.searchTerm} searchResults={searchResults} />
    </div>
}

export default SearchLanding;